import React from 'react';
import PropTypes from 'prop-types';
import { SubmissionError } from 'redux-form';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { parse } from 'qs';
//
import {
  login,
  logout,
  resendMFAValidationCode,
  validateMFACode,
  clearReLoginData,
} from 'store/actions/auth.actions';
import { getReduxFormError } from 'utils/forms/getReduxFormError';
import { ROUTES } from 'config/constants';
import { LoginForm } from './LoginForm';
import { MfaCodeForm } from './MfaCodeForm';
import { isCompletedAuth } from 'utils/auth';
import { processLoginRedirect } from 'utils/redirectUtils';

@connect(
  ({ authState }) => ({
    authState,
  }),
  (dispatch) => ({
    login: bindActionCreators(login, dispatch),
    logout: bindActionCreators(logout, dispatch),
    resendMFAValidationCode: bindActionCreators(
      resendMFAValidationCode,
      dispatch,
    ),
    validateMFACode: bindActionCreators(validateMFACode, dispatch),
    clearReLoginData: bindActionCreators(clearReLoginData, dispatch),
  }),
)
export default class LoginPage extends React.PureComponent {
  static propTypes = {
    authState: PropTypes.object,
  };

  static defaultProps = {
    authState: {},
  };

  handleSubmit = async (values) => {
    const { history } = this.props;

    const response = await this.props.login(values);
    const userIsDeleted =
      response.code === 'sec.forbidden' &&
      response.errors.some((item) => item.code === 'bus.user_is_deleted');

    if (userIsDeleted) {
      history.push(ROUTES.DELETED_USER);
    }
    if (response?.code !== 'success') {
      throw new SubmissionError(getReduxFormError(response));
    }

    if (!isCompletedAuth(response.data)) {
      return;
    }

    this.props.clearReLoginData();

    const {
      location: { search = '' },
    } = this.props;
    const { redirectUrl, userGroups, userId } = parse(search, {
      ignoreQueryPrefix: true,
    });

    const { authInfo = {} } = response.data;
    processLoginRedirect(
      redirectUrl,
      userGroups,
      userId,
      authInfo,
      history.push,
    );
  };

  handleMFASubmit = async (values) => {
    const { history } = this.props;
    const response = await this.props.validateMFACode(values);
    if (response?.code !== 'success') {
      throw new SubmissionError(getReduxFormError(response));
    }

    this.props.clearReLoginData();

    const {
      location: { search = '' },
    } = this.props;
    const { redirectUrl, userGroups, userId } = parse(search, {
      ignoreQueryPrefix: true,
    });

    const { authInfo = {} } = response.data;
    processLoginRedirect(
      redirectUrl,
      userGroups,
      userId,
      authInfo,
      history.push,
    );
  };

  render() {
    const { authState = {} } = this.props;
    const { isAuthProcessed } = authState;

    return authState.accessToken && !authState.isAuth ? (
      <MfaCodeForm
        isFormProcessed={isAuthProcessed}
        onSubmit={this.handleMFASubmit}
        onBackToLogin={this.props.logout}
        onResendCode={this.props.resendMFAValidationCode}
      />
    ) : (
      <LoginForm
        isFormProcessed={isAuthProcessed}
        onSubmit={this.handleSubmit}
      />
    );
  }
}
